import { Tooltip, Typography } from '@mui/material';
import { toDisplayString } from 'customers/db-servers-detailed-view/TessellAgentLcmInfoTab.utils';

type EllipsizedValueProps = {
  value: unknown;
  valueTextSx?: Record<string, unknown>;
};

export const EllipsizedValue = ({ value, valueTextSx }: EllipsizedValueProps) => {
  const str = toDisplayString(value);
  const isLong = str.length > 80 || str.includes('\n');
  const shown = isLong ? str.replace(/\s+/g, ' ').slice(0, 120) + '…' : str;

  return (
    <Tooltip
      title={<pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{str}</pre>}
      placement="right"
      arrow
    >
      <Typography
        variant="body2"
        sx={{
          ...(valueTextSx || {}),
          cursor: isLong ? 'help' : 'default',
        }}
      >
        {shown}
      </Typography>
    </Tooltip>
  );
};

